import type { CSSProperties } from 'react';
import homeIcon from './icons/home.svg';
import clientIcon from './icons/client.svg';
import executorIcon from './icons/executor.svg';
import chatIcon from './icons/chat.svg';
import orderIcon from './icons/order.svg';
import productIcon from './icons/product.svg';
import taskIcon from './icons/task.svg';
import priceIcon from './icons/price.svg';
import subscriptionIcon from './icons/subscription.svg';
import promoIcon from './icons/promo.svg';
import cashbackIcon from './icons/cashback.svg';
import bonusIcon from './icons/bonus.svg';
import cityIcon from './icons/city.svg';
import blogIcon from './icons/blog.svg';
import notificationIcon from './icons/notification.svg';
import settingsIcon from './icons/settings.svg';
import telegramIcon from './icons/telegram.svg';
import memoryIcon from './icons/memory.svg';
import statisticsIcon from './icons/statistics.svg';
import versionIcon from './icons/version.svg';
import tagIcon from './icons/tag.svg';
import policyIcon from './icons/policy.svg';
import accessIcon from './icons/access.svg';
import styles from './Sidebar.module.scss';

export type SidebarIconName =
    | 'home'
    | 'client'
    | 'executor'
    | 'chat'
    | 'order'
    | 'product'
    | 'task'
    | 'price'
    | 'subscription'
    | 'promo'
    | 'cashback'
    | 'bonus'
    | 'city'
    | 'blog'
    | 'notification'
    | 'settings'
    | 'telegram'
    | 'memory'
    | 'statistics'
    | 'version'
    | 'tag'
    | 'policy'
    | 'access';

const iconUrls: Record<SidebarIconName, string> = {
    home: homeIcon,
    client: clientIcon,
    executor: executorIcon,
    chat: chatIcon,
    order: orderIcon,
    product: productIcon,
    task: taskIcon,
    price: priceIcon,
    subscription: subscriptionIcon,
    promo: promoIcon,
    cashback: cashbackIcon,
    bonus: bonusIcon,
    city: cityIcon,
    blog: blogIcon,
    notification: notificationIcon,
    settings: settingsIcon,
    telegram: telegramIcon,
    memory: memoryIcon,
    statistics: statisticsIcon,
    version: versionIcon,
    tag: tagIcon,
    policy: policyIcon,
    access: accessIcon,
};

/** Показывает фирменную контурную иконку раздела в навигации VOX */
export const SidebarIcon = ({ name }: { name: SidebarIconName }) => {
    const iconUrl = iconUrls[name];

    const iconStyle: CSSProperties = {
        maskImage: `url("${iconUrl}")`,
        WebkitMaskImage: `url("${iconUrl}")`,
    };

    return <span
        className={styles.sidebarIcon}
        style={iconStyle}
        aria-hidden="true"
    />;
};
